/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  /**
   * Коллекция с товарами для поиска
   */
  app.Search = app.ItemPageableCollection.extend({
    model: app.Model,
    categoryId: 0,
    sortTypes: ['rank', 'price', '-price', 'price-unit', '-price-unit', '-date', 'name', 'sid', 'discount', 'mean_rating'],
    suggest: false,
    translit: false,
    similarQueries: [],
    correct: 1,
    // fetchCounter = 1 нужен, чтобы вьюхи не пытались искать элементы на странице
    fetchCounter: 1,
    inStock: false,
    additionalOptions: [
      'isShowOneItemInSearch',
    ],

    /**
     * @inheritDoc
     */
    url: function () {
      var endPoint = app.isNewSearchEnabled ? 'search' : 'item-search';
      return app.entryScriptName + '/api/v3/' + endPoint + '/';
    },

    /**
     * @inheritDoc
     */
    initialize: function (models, options) {
      if (options.suggest && options.suggest instanceof app.Model) {
        this.suggest = options.suggest;
      }
      app.ItemPageableCollection.prototype.initialize.apply(this, arguments);
      if (!this.isShowOneItemInSearch) {
        this.listenTo(this, 'sync', this.redirectToItem);
      }
      this.listenTo(this, 'error', this.resetCollection);
    },

    state: {
      firstPage: 1,
      pageSize: 20,
      order: 0
    },

    defaults: {
      pageSize: 20,
      sort: 'rank',
      viewtype: 'cards',
      f: 'null',
      mode: 'server',
      categoryQuery: '',
      correct: 1
    },

    /**
     * @inheritDoc
     */
    parseRecords: function (resp, options) {
      var that = this;
      if (resp.redirect_to) {
        app.helpers.OkoHelper.awaitPush({
          "n": "custom",
          "category": "redirect",
          'custom_str': [resp.type],
        }, function () {
          that.redirectTo(resp.redirect_to);
        });
        return;
      }

      if (resp._suggest && resp._suggest.type) {
        this.suggest.set('word', resp._suggest.q);
      } else if (resp._suggest && resp._suggest.word) {
        this.suggest.set(resp._suggest);
      } else {
        this.suggest.clear();
      }

      if (resp._translit && resp._translit.length) {
        this.translit = resp._translit;
        this.suggest.set('word', resp._translit);
      } else {
        this.translit = false;
      }
      if (resp.items.length > 0) {
        var query = this.suggest.get('word') || this.query;
        this.trigger('in-stock', query);
      }
      if (resp._similarQueries && resp._similarQueries.length) {
        this.similarQueries = resp._similarQueries;
      } else {
        this.similarQueries = false;
      }
      return app.ItemPageableCollection.prototype.parseRecords.apply(this, [resp, options]);
    },

    /**
     * @inheritDoc
     */
    setQueryParams: function () {
      var that = this;
      this.queryParams = {
        totalRecords: function () {
          return that.totalPages;
        },
        currentPage: 'page',
        pageSize: 'per-page',
        currency: function () {
          return that.currencyId;
        },
        sort: function () {
          return that.sort === 'rank' && app.isNewRankEnabled ? 'rating' : that.sort;
        },
        viewtype: function () {
          return that.viewtype;
        },
        f: function () {
          return that.filter;
        },
        q: function () {
          return that.query;
        },
        category_id: function () {
          var categoryId = that.categoryId;
          if (!categoryId) {
            return '';
          }
          return categoryId;
        },
        correct: function () {
          return that.correct;
        },
        with_adult: 1,
      };

      this.queryParams.expand = [
        'small_modifiers',
        'cart_item',
        'wish_item',
        'attrs',
        'nestedUnit',
        'files',
        'photo_sizes',
        'badges',
        'retail_fee_markup',
      ].join(',');
      if (app.isNewSearchEnabled) {
        this.queryParams.fields = app.API_SEARCH_FIELDS.join(',');
        this.queryParams.expand += ',special_offer_badge_label';
      }
    },

    /**
     * Устанавливает параметр поисковой строки
     * @param {String} query Поисковый запрос
     * @returns {app.Search}
     */
    setQuery: function (query) {
      if (!query) {
        return this;
      }
      this.query = app.helpers.StringHelper.normalizeQuery(query);
      this.trigger('query-updated', this.query);
    },

    /**
     * Устанавливает параметр отвечающий за исправление опечаток
     * @param correct
     */
    setCorrect: function (correct) {
      if (this.correct !== correct) {
        this.loadFilters = true;
      }
      this.correct = correct;
    },

    /**
     * @inheritDoc
     */
    fetch: function () {
      if (app.isMobile && this.fetchCounter === 1) {
        this.setLoadFilters(0);
      }
      app.ItemPageableCollection.prototype.fetch.apply(this, arguments);
    },

    /**
     * Определяет применен ли параметр фильтрации
     */
    _hasFilterParameter: function () {
      return this.filter && this.filter !== 'null';
    },

    /**
     * Определяем необходимо ли перенаправлять на страницу товара, если необходимо, то перенаправляем.
     */
    redirectToItem: function () {
      // если найден только один товар, то перенаправляем на страницу товара
      if (this.state.totalRecords === 1 && !this._hasFilterParameter()) {
        var singleModel = this.models[0],
          url = '';
        if (singleModel) {
          url = singleModel.get('itemUrl');
          if (url) {
            this.redirectTo(url);
          }
        }
      }
    },

    /**
     * Редиректит на переданный урл.
     * @param {String} url
     */
    redirectTo: function (url) {
      if (url.replace(/\//g, '') === 'https:') {
        app.helpers.RedirectHelper.locationAssign('catalog');
      } else {
        app.helpers.RedirectHelper.locationAssign(url);
      }
    },

    /**
     * Сбрасывание коллекции, если произошла ошибка при запросе.
     * @param {app.Search} collection - текущая коллекция
     * @param {Object} response - ответ
     * @param {Object} request - запрос
     */
    resetCollection: function (collection, response, request) {
      if (
        request && request.xhr
        && request.xhr.status !== 0
        && request.xhr.statusText !== 'abort'
      ) {
        this.filter = this.defaults.f;
        this.state.totalRecords = 0;
        this.state.totalPages = 0;
        this.suggest.clear();
        this.inStock = true;
        Backbone.trigger('clear-filters');
        Backbone.trigger('parseFilterData');
        this.trigger('search-collection:reset');
        this.reset();
      }
    }
  });
})();

}.call(window));